import Typography from "@mui/material/Typography";
import {LinearProgress, Skeleton, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import AudiotrackIcon from "@mui/icons-material/Audiotrack";

const UploadProgress = ({uploadPercent}) => {
    return <Stack direction="column" position="relative" spacing={0}>
        <Box position="relative">
            <Skeleton variant="rounded" sx={{borderBottomLeftRadius: 0, borderBottomRightRadius: 0}} width={100} height={110} />
            <AudiotrackIcon sx={{fontSize: 40, position: "absolute", left: "50%", top: "50%", transform: "translate(-50%, -50%)" }} />
            <Typography variant="body2" position="absolute" bottom={0} left="50%" sx={{transform: "translateX(-50%)"}}>{parseInt(uploadPercent)}%</Typography>
        </Box>
        <LinearProgress variant="determinate" value={uploadPercent} />
    </Stack>
}

export default UploadProgress;